// extracted by mini-css-extract-plugin
export default {"gallery":"c-n_gU","gallery__header":"c-n_gV","gallery__thumbs":"c-n_gW"};